import templateUrl from 'emun.customer/customer-contact.popover.htm'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const CustomerContactPopover = {
    open(options) {
        return modals.open(angular.extend({
            size: 'lg',
            // placement: 'right',
            //backdrop: false,
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: function(options) {
				let $ctrl = this;
                $ctrl.customer = options.customer;
                $ctrl.contactId = options.contactId;
                $ctrl.locationmode = options.locationmode;
                $ctrl.dismiss = function() {
                    const $ctrl = this;
                    $ctrl.$dismiss();
                }
            },
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

export default CustomerContactPopover;